import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { IndexedDBService } from "../../../routes/services/db/indexedDb.service";

@Component({
  selector: "app-loading-time",
  templateUrl: `./loading_time.html`,
  styleUrls: ["../loading.scss"]
})
export class LoadingTimeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() petition: boolean = true;
  @Input() url: string = "";
  @Input() type: 1 | 2 = 1;

  view: boolean = true;

  estimate: number = 0;
  percent: number = 0;

  seconds: number = 0;
  interval: any = null;
  requestKey: string = "";

  circumference: number = 2 * Math.PI * 70;
  constructor(public indexedDBService: IndexedDBService) {}
  ngOnDestroy(): void {
    this.cancelTimer();
  }
  ngOnChanges(changes: SimpleChanges): void {
    const petitionChange = changes["petition"];
    const urlChange = changes["url"];

    // Si la petición se apagó (true -> false): parar todo
    if (petitionChange && petitionChange.previousValue && !petitionChange.currentValue) {
      this.percent = 100;
      this.requestKey = "";
      this.cancelTimer();
      return;
    }

    // Solo arrancar si HAY petición activa y HAY url
    const petitionIsTrue = this.petition === true;
    const hasUrl = !!this.url;
    if (!petitionIsTrue || !hasUrl) {
      // Si se crea sin petición activa (p. ej. datos ya en caché), no debe quedar visible
      if (!petitionIsTrue) {
        this.view = false;
      }
      return;
    }

    const petitionTurnedOn =
      !!petitionChange && petitionChange.currentValue === true && petitionChange.previousValue !== true;
    const urlChanged = !!urlChange && urlChange.currentValue !== urlChange.previousValue;
    const nextRequestKey = `${this.type}-${this.url}`;

    if (petitionTurnedOn || urlChanged || (!this.interval && this.requestKey !== nextRequestKey)) {
      this.requestKey = nextRequestKey;
      this.cancelTimer(false);
      this.seconds = 0;
      this.percent = 0;
      this.view = true;
      this.TimerDetectEstimate();
    }
  }
  ngOnInit(): void {}
  TimerDetectEstimate = async () => {
    if (!this.url || !this.petition) return; // seguridad extra

    this.indexedDBService.getByIndex("urls", "url", this.url).subscribe(
      (resp: any) => {
        this.estimate = resp ? resp.seconds : 4;
        this.startTimerIfPending();
      },
      () => {
        this.estimate = 4;
        this.startTimerIfPending();
      }
    );
  };
  /**
   * Inicia el timer solo si la petición sigue activa; la lectura de IndexedDB es
   * asíncrona y la petición pudo terminar antes.
   */
  private startTimerIfPending(): void {
    if (!this.petition) {
      this.view = false;
      return;
    }
    this.startTimer();
  }
  startTimer(): void {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.seconds += 1;
        const calculate = (this.seconds / this.estimate) * 100;
        this.percent = Math.min(Math.max(calculate, 0), 100);
      }, 1000);
    }
  }

  cancelTimer(hide: boolean = true): void {
    // Se oculta aunque el timer no haya alcanzado a iniciar
    if (hide) {
      this.view = false;
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
  getBackground(progress: number): string {
    const angle = (progress / 100) * 360;
    return `conic-gradient(#007bff ${angle}deg, #e6e6e6 ${angle}deg)`;
  }
}
